import { render, staticRenderFns } from "./GSDDAllergyComponent.vue?vue&type=template&id=2baa6464&scoped=true"
import script from "./GSDDAllergyComponent.vue?vue&type=script&lang=ts"
export * from "./GSDDAllergyComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baa6464",
  null
  
)

export default component.exports